import public_apis from "@/services/public";
import user_master from "@/services/user/master";
import admin_master_test_kit from "@/services/admin/master/test-kit";
import admin_master_how_heard from "@/services/admin/master/how-heard";
import admin_master_clinic from "@/services/admin/master/clinic";
import i18n from '@/i18n/i18n'

export default {
  async getStates({ commit, state }, data) {
    if (state.states.length === 0 || data.forced) {
      await public_apis.state_list(data).then(response => {
        commit("updateStates", response.data.data.states);
      });
    }
  },
  async getAllStates({ commit, state }, data) {
    if (state.states.length === 0 || data.forced) {
      await public_apis.stateAll(data).then(response => {
        commit("updateStates", response.data.data.states);
      });
    }
  },

  async getMailingStates({ commit, state }, data) {
    if (state.mailingStates.length === 0 || data.forced) {
      await public_apis.state_list(data).then(response => {
        commit("updateMailingState", response.data.data.states);
      });
    }
  },
  async getAllMailingStates({ commit, state }, data) {
    if (state.mailingStates.length === 0 || data.forced) {
      await public_apis.stateAll(data).then(response => {
        commit("updateMailingState", response.data.data.states);
      });
    }
  },

  async getRaces({ commit, state }, data) {
    if(data['check_is_active'] == false){
      if (state.races.length === 0 || data.forced) {
        await public_apis.race_list().then(response => {
          commit("updateRaces", response.data.data.races);
        });
      }
    }else{
      let input = {
        is_active: true
      }
      if (state.races.length === 0 || data.forced) {
        await public_apis.race_list(input).then(response => {
          commit("updateRaces", response.data.data.races);
        });
      }
    }
  },
  async getGenders({ commit, state }, data) {
    let input = {
      is_active: true
    }
    if (state.genders.length === 0 || data.forced) {
      await public_apis.gender_list(input).then(response => {
        commit("updateGenders", response.data.data.gender_identities);
      });
    }
  },
  async getSexWiths({ commit, state }, data) {
    let input = {
      is_active: true
    }
    if (state.sexWiths.length === 0 || data.forced) {
      await public_apis.sex_with_list(input).then(response => {
        let list = response.data.data.sex_with;
        list.sort((a, b) => {
          if (a.order === null) return 1;
          if (b.order === null) return -1;
          return a.order - b.order;
        });
        commit("updateSexWiths", list);
      });
    }
  },
  async getSexAtBirths({ commit, state }, data) {
    let input = {
      is_active: true
    }
    if (state.sexAtBirths.length === 0 || data.forced) {
      await public_apis.sex_at_birth_list(input).then(response => {
        commit("updateSexAtBirth", response.data.data.sex_at_birth);
      });
    }
  },
  async getTestKits({ commit, state, getters }, data) {
    if (state.testkits.length === 0 || data.forced) {
      var response;
      if (getters.isUserType("user")) {
        response = await user_master.testKitList(data);
      } else {
        response = await admin_master_test_kit.list(data);
      }
      if (response) {
        commit("updateTestKit", response.data.data["test-kits"]);
      }
    }
  },
  async getHowHeard({ commit, state, getters }, data) {
    if (state.howheard.length === 0 || data.forced) {
      var response;
      if (getters.isUserType("user")) {
        let input = {
          is_active: true
        }
        response = await user_master.howHeardList(input);

        if(response.data.data['how-heard'] && response.data.data['how-heard'].length){
        response.data.data['how-heard'].push({
          name: "Other",
          id: "other_howheard"
        });
      }else{
        response.data.data['how-heard'].push({
          name: "No Choices Available",
          id: "no_choices_available"
        });
      }
      } else {
        response = await admin_master_how_heard.list(data);
      }
      if (response) {
        commit("updateHowHeard", response.data.data["how-heard"]);
      }
    }
  },
  async getClinic({ commit, state, getters }, data) {
    if (state.clinics.length === 0 || data.forced) {
      var response;
      if (getters.isUserType("user")) {
        let input = {
          is_active: true
        }
        response = await user_master.clinicList(input);
        let other_clinic_name ;
        if(i18n.locale=='en'){
          other_clinic_name = 'Other Clinic';
        }else{
          other_clinic_name = 'Otra Clínica';
        }
        response.data.data.clinic.push({
          name: other_clinic_name,
          id: "other_clinic"
        });
      } else {
        response = await admin_master_clinic.list(data);
      }
      if (response) {
        commit("updateClinic", response.data.data.clinic);
      }
    }
  }
};
